import React from 'react'
import Rightaside from '../reusable/Rightaside'
import { IMAGES } from '../utils/images'
import { HOME_UNIVERSITIES, HOME_UNIVERSITIES_ALIGNED_TRAINING, HOME_UNIVERSITIES_ASIDE, HOME_UNIVERSITIES_LEFT_ASIDE, HOME_UNIVERSITIES_RIGHT_ASIDE, UNIVERSITIES_CARDS } from '../utils/constants'
import TopBarCards from '../reusable/TopBarCards'
import LeftAside from '../reusable/Leftaside'
import CourseCard from '../reusable/Course-card'

const ForUniversities = () => {
  return (
    <div className='outlet-render'>
    <Rightaside {...HOME_UNIVERSITIES}/>
    <div className='business-cards-container'>
   {
    UNIVERSITIES_CARDS.map((item)=>{
      return <TopBarCards {...item}/>
    })
   }
   </div>
      <div className='partners-main'>
      <img src={IMAGES.PARTNERS} alt="partners"/>
      <h1 className='partners-heading'>Provide students with access to 100+ courses from top universities and industry leaders.</h1>
      </div>
      <LeftAside {...HOME_UNIVERSITIES_LEFT_ASIDE}/>
      <Rightaside {...HOME_UNIVERSITIES_RIGHT_ASIDE}/>
      <div>
      <CourseCard {...HOME_UNIVERSITIES_ALIGNED_TRAINING}/>
      </div>
      <LeftAside {...HOME_UNIVERSITIES_ASIDE}/>
    </div>
  )
}

export default ForUniversities